(function ($) {

    /*------------------------------------*\
        DEVHUB CPT CRUD
        Status selects and delete buttons on CPT archive cards.
        Each action posts to its AJAX handler using the appropriate nonce.

        Status selects:  .js-{type}-status-select[data-post-id]
        Delete buttons:  .js-{type}-delete[data-post-id]
    \*------------------------------------*/

    $.fn.devhubCptCrud = function () {

        /* ── Shared status update ────────────────────────────────── */

        function updateStatus(action, nonce, postId, status) {

            var $card = $('.devhub-cpt-card[data-post-id="' + postId + '"]');

            $.ajax({
                url:  devhubAjax.ajaxUrl,
                type: 'POST',
                data: {
                    action:  action,
                    post_id: postId,
                    status:  status,
                    nonce:   nonce
                },
                success: function (resp) {

                    if (resp.success) {

                        // Remove all status classes
                        $card.removeClass('devhub-cpt-card--status-approved devhub-cpt-card--status-rejected devhub-cpt-card--status-draft devhub-cpt-card--status-in-review devhub-cpt-card--status-locked devhub-cpt-card--status-ready devhub-cpt-card--status-deployed');

                        // Add new status class
                        $card.addClass('devhub-cpt-card--status-' + status);

                        // Fade out rejected cards, restore others
                        if (status === 'rejected') {
                            $card.animate({ opacity: 0.3 }, 300);
                        } else {
                            $card.animate({ opacity: 1 }, 300);
                        }

                        // Re-render the current tab so the grid re-partitions
                        // (approved → collapsed row, rejected → Rejected section,
                        // cascades → all affected children move too). Otherwise
                        // the operator sees stale markup — the card looks faded
                        // in place but its siblings' status doesn't reflect any
                        // cascade that fired server-side.
                        if (document.getElementById('tf-project-hub-main')) {
                            document.dispatchEvent(new CustomEvent('tf:hub-refresh-current-tab', {
                                detail: { reason: 'design-status-changed', postId: postId, status: status }
                            }));
                        }

                    }

                }
            });

        }

        /* ── Shared delete ───────────────────────────────────────── */

        function deletePost(action, nonce, postId, $card) {

            if (!window.confirm('Delete this item? This cannot be undone.')) {
                return;
            }

            $card.css('opacity', '0.4');

            $.ajax({
                url:  devhubAjax.ajaxUrl,
                type: 'POST',
                data: {
                    action:  action,
                    post_id: postId,
                    nonce:   nonce
                },
                success: function (resp) {

                    if (resp.success) {
                        $card.fadeOut(250, function () { $(this).remove(); });
                    } else {
                        $card.css('opacity', '');
                        var msg = resp.data && resp.data.message ? resp.data.message : 'Delete failed.';
                        window.alert('Error: ' + msg);
                    }

                },
                error: function (xhr) {
                    $card.css('opacity', '');
                    window.alert('Delete request failed (' + xhr.status + '). Check the console.');
                }
            });

        }

        /* ── Approve (quick-set status) ─────────────────────────── */

        $(document).on('click', '.js-approve-btn', function () {

            var $btn    = $(this);
            var $card   = $btn.closest('.devhub-cpt-card');
            var postId  = $btn.data('post-id');
            var $select = $card.find('.devhub-cpt-card__status-select');

            if (!$select.length) {
                return;
            }

            // Find the first approval-tier option
            var approveSlug = '';
            $select.find('option').each(function () {
                var val = $(this).val();
                if (val === 'approved' || val === 'locked' || val === 'ready' || val === 'deployed') {
                    approveSlug = val;
                    return false; // break
                }
            });

            if (!approveSlug) {
                return;
            }

            // Update the select — triggers the existing change handler
            $select.val(approveSlug).trigger('change');

            // Visual feedback
            $btn.addClass('devhub-cpt-card__approve--done');

        });

        /* ── Design ─────────────────────────────────────────────── */

        $(document).on('change', '.js-design-status-select', function () {

            updateStatus(
                'devhub_update_design_status',
                devhubAjax.designNonce,
                $(this).data('post-id'),
                $(this).val()
            );

        });

        $(document).on('click', '.js-design-action', function () {

            var $btn    = $(this);
            var status  = $btn.data('status');
            var type    = status === 'approved' ? 'approve' : 'reject';
            var $actions = $btn.closest('.devhub-cpt-card__actions');

            updateStatus(
                'devhub_update_design_status',
                devhubAjax.designNonce,
                $btn.data('post-id'),
                status
            );

            // Approval is final — collapse the actions row so it can't be
            // un-approved from the card. PHP suppresses the row on reload.
            if (status === 'approved') {
                $actions.slideUp(200, function () { $(this).remove(); });
                return;
            }

            $actions.find('.js-design-action').removeClass('devhub-cpt-card__approve--done devhub-cpt-card__reject--done');
            $btn.addClass('devhub-cpt-card__' + type + '--done');

        });

        $(document).on('click', '.js-design-delete', function (e) {

            e.stopPropagation();

            var $btn = $(this);

            deletePost(
                'devhub_delete_design',
                devhubAjax.designNonce,
                $btn.data('post-id'),
                $btn.closest('.devhub-cpt-card')
            );

        });

        /* ── Component ───────────────────────────────────────────── */

        $(document).on('change', '.js-component-status-select', function () {

            updateStatus(
                'devhub_update_component_status',
                devhubAjax.componentNonce,
                $(this).data('post-id'),
                $(this).val()
            );

        });

        $(document).on('click', '.js-component-delete', function () {

            var $btn = $(this);

            deletePost(
                'devhub_delete_component',
                devhubAjax.componentNonce,
                $btn.data('post-id'),
                $btn.closest('.devhub-cpt-card')
            );

        });

        // ── Component code field save ──────────────────────────────

        $(document).on('click', '.js-component-code-save', function () {

            var $btn   = $(this);
            var field  = $btn.data('field');
            var postId = $btn.data('post-id');
            var $editor = $btn.closest('.devhub-code-block').find('.js-component-code[data-field="' + field + '"]');
            var value  = $editor.val();

            $btn.text('Saving...').prop('disabled', true);

            $.post(devhubAjax.ajaxUrl, {

                action:  'devhub_save_component_code',
                nonce:   devhubAjax.componentNonce,
                post_id: postId,
                field:   field,
                value:   value

            }, function (response) {

                if (response.success) {

                    $btn.text('Saved').addClass('devhub-code-block__save--success');

                    setTimeout(function () {
                        window.location.reload();
                    }, 800);

                } else {

                    $btn.text('Error').prop('disabled', false);

                }

            }).fail(function () {

                $btn.text('Error').prop('disabled', false);

            });

        });

        // ── Copy from textarea (override for editable code blocks) ──

        $(document).on('click', '.devhub-code-block__actions .js-copy-btn', function () {

            var $block = $(this).closest('.devhub-code-block');
            var $editor = $block.find('.js-component-code');

            if ($editor.length) {

                $editor[0].select();
                document.execCommand('copy');
                $(this).text('Copied!');

                var $btn = $(this);
                setTimeout(function () { $btn.text('Copy'); }, 2000);

                return false; // prevent default copy handler

            }

        });


        return this;

    };

}(jQuery));
